export const PHONE = {
    display: "+40 (767) 880 465",
    raw: "+40767880465",
};

export const WHATSAPP_URL = "https://wa.me/40767880465";
export const FACEBOOK_URL = "https://facebook.com/";
export const INSTAGRAM_URL = "https://instagram.com/";
export const MERO_URL = "https://mero.ro/p/gan-barber-shop";

export const ADDRESS = "Strada Smârdan nr. 18, Bragadiru";
export const MAPS_EMBED =
    "https://www.google.com/maps?q=Strada%20Smardan%2018%20Bragadiru&output=embed";

export const NAV_LINKS = [
    { label: "Acasă", target: "hero" },
    { label: "Despre", target: "despre" },
    { label: "Servicii", target: "servicii" },
    { label: "Galerie", target: "galerie" },
    { label: "Locație", target: "locatie" },
    { label: "Contact", target: "contact" },
];

export const SERVICES = [
    {
        title: "Tuns",
        icon: "Scissors",
        desc: "Tunsoare clasică sau modernă, adaptată perfect formei feței și stilului tău.",
    },
    {
        title: "Skin Fade",
        icon: "Sparkles",
        desc: "Degrade impecabil, de la piele la lungime, executat cu precizie milimetrică.",
    },
    {
        title: "Tuns + Barbă",
        icon: "UserRound",
        desc: "Pachet complet pentru un look echilibrat — tunsoare și barbă conturate armonios.",
    },
    {
        title: "Contur Barbă",
        icon: "Wand2",
        desc: "Definirea și conturarea bărbii cu briciul, pentru linii curate și un aspect îngrijit.",
    },
    {
        title: "Aranjat Păr",
        icon: "Wind",
        desc: "Styling profesional cu produse premium, pentru o ținută care rezistă toată ziua.",
    },
    {
        title: "Tuns Copii",
        icon: "Baby",
        desc: "Răbdare, blândețe și o experiență plăcută pentru cei mici, într-un mediu prietenos.",
    },
    {
        title: "Vopsit Barbă",
        icon: "Paintbrush",
        desc: "Vopsire profesională a bărbii pentru un aspect uniform, natural și îngrijit.",
    },
];

export const WHY_US = [
    {
        title: "Profesionalism",
        desc: "Frizeri cu experiență, tehnică pusă la punct și pasiune pentru fiecare tunsoare.",
    },
    {
        title: "Atenție la detalii",
        desc: "Fiecare linie, fiecare contur — totul executat cu grijă, până la ultimul milimetru.",
    },
    {
        title: "Produse premium",
        desc: "Lucrăm exclusiv cu produse de calitate superioară pentru rezultate impecabile.",
    },
    {
        title: "Atmosferă relaxantă",
        desc: "Un mediu modern și primitor, în care fiecare vizită devine un moment de răsfăț.",
    },
];

export const GALLERY = [
    {
        src: "https://images.unsplash.com/photo-1759134198561-e2041049419c",
        alt: "Frizeri tunzând clienți într-un salon modern",
    },
    {
        src: "https://images.pexels.com/photos/12074386/pexels-photo-12074386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
        alt: "Skin fade impecabil văzut din spate",
    },
    {
        src: "https://images.pexels.com/photos/4351727/pexels-photo-4351727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
        alt: "Frizer tunzând cu precizie",
    },
    {
        src: "https://images.pexels.com/photos/5853395/pexels-photo-5853395.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
        alt: "Aranjat barbă profesional",
    },
    {
        src: "https://images.unsplash.com/photo-1773904215697-e6c21fc27ac2",
        alt: "Scaune de barber premium în salon",
    },
    {
        src: "https://images.unsplash.com/photo-1675599193741-e6f078a65fbd",
        alt: "Unelte profesionale de frizerie",
    },
    {
        src: "https://images.pexels.com/photos/9153970/pexels-photo-9153970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
        alt: "Contur barbă cu briciul",
    },
    {
        src: "https://images.pexels.com/photos/17027433/pexels-photo-17027433.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
        alt: "Atmosfera din salon, iluminat ambiental",
    },
];

export const SCHEDULE = [
    { day: "Luni – Vineri", hours: "09:00 – 20:00" },
    { day: "Sâmbătă", hours: "09:00 – 18:00" },
    { day: "Duminică", hours: "Închis", closed: true },
];
